import { createLabelObjects } from "../../../common/utils/helpers";
import ResultsAccordionContent from "../common/ResultsAccordionContent";
import ResultsAccordionTrigger from "../common/ResultsAccordionTrigger";
import ResultsPieChart from "../common/ResultsPieChart";
import FootprintBreakdown from "./breakdownComparison/FootprintBreakdown";
import { RegionalNamespaces } from "@pslifestyle/common/src/constants/translations";
import {
  CalculatedAnswer,
  CategorizedFootprint,
} from "@pslifestyle/common/src/types/questionnaireTypes";
import * as Accordion from "@radix-ui/react-accordion";
import { useTranslation } from "react-i18next";

interface IBreakdownComparisonProps {
  ordinaryAnswers: CalculatedAnswer[];
  totalFootprint: number;
  categorizedFootprint: CategorizedFootprint;
}

const BreakdownComparison = ({
  ordinaryAnswers,
  totalFootprint,
  categorizedFootprint,
}: IBreakdownComparisonProps) => {
  const { t, i18n } = useTranslation("results");

  const questionAndRecommendationTranslations = i18n.getResourceBundle(
    i18n.language,
    RegionalNamespaces.QUESTION_AND_RECOMMENDATIONS,
  );

  const footprintByLabels =
    ordinaryAnswers &&
    createLabelObjects(ordinaryAnswers, questionAndRecommendationTranslations);

  return (
    <Accordion.Item value="category-comparison">
      <ResultsAccordionTrigger
        trackLocation="footprint-breakdown"
        backgroundImagePath="/images/icons/piechart.svg"
      >
        {t("breakdownTitle", { ns: "results" })}
      </ResultsAccordionTrigger>
      <ResultsAccordionContent>
        <div className="mb-4">
          <ResultsPieChart
            totalFootprint={totalFootprint}
            categorizedFootprint={categorizedFootprint}
          />
        </div>

        <FootprintBreakdown footprintByLabelArray={footprintByLabels || []} />
      </ResultsAccordionContent>
    </Accordion.Item>
  );
};

export default BreakdownComparison;
